export default __webpack_public_path__ + "static/media/128.8a3da052.jpg";